const TRUST_ITEMS = [
  { icon: 'ri-shield-check-fill', label: 'Licensed & Insured', desc: 'State-certified contractor' },
  { icon: 'ri-file-list-3-fill', label: 'Insurance Claim Help', desc: 'We handle all paperwork' },
  { icon: 'ri-medal-2-fill', label: 'Premium Materials', desc: 'Industry-leading products' },
  { icon: 'ri-map-pin-2-fill', label: 'Locally Rooted', desc: 'Utah-based experts' },
];

export default function TrustBar() {
  return (
    <section className="bg-charcoal-light py-6 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-xl overflow-hidden">
          {TRUST_ITEMS.map((item) => (
            <div key={item.label} className="flex items-center gap-4 bg-charcoal-light px-6 py-5">
              <div className="w-11 h-11 flex items-center justify-center bg-brand-orange/15 rounded-lg flex-shrink-0">
                <i className={`${item.icon} text-brand-orange text-2xl`}></i>
              </div>
              <div>
                <p className="font-heading font-800 text-white text-sm uppercase tracking-wide">{item.label}</p>
                <p className="font-body text-white/50 text-xs mt-0.5">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
